/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import TopNavigation from "../../layouts/top-navigation/TopNavigation";
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import TourOutlinedIcon from '@mui/icons-material/TourOutlined';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../useStore";
import { createdTestDetails, reset } from "../../features/Test/testSlice";
import swal from "sweetalert";
import { Wave } from "../../components/TableOptions";
import { BiErrorAlt } from "react-icons/bi";


const TestDetails = () => {
	const { id } = useParams();
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const { createdTestDetailsdata, createdTestDetailsisError, createdTestDetailsmessage, createdTestDetailsisLoading } = useAppSelector((state: { test: any; }) => state.test)



	useEffect(() => {
		dispatch(createdTestDetails(id));
	}, [dispatch, id])

	useEffect(() => {
		if (createdTestDetailsisError) {
			swal({
				title: "error",
				text: createdTestDetailsmessage,
				icon: "error"
			})
			dispatch(reset())
		}

	}, [createdTestDetailsisError, createdTestDetailsmessage, dispatch])


	const handleBack = () => {
		navigate(-1)
	}
	const handlePreview = () => {
		navigate('/testpreview', { state: { data: createdTestDetailsdata?.data?.TestQuestions } });
	}

	return (
		<div id="screen-wrapper">
			<TopNavigation />
			<main className="main-body">
				<div>
					<h1>Pre-employment screening assessment <br />to hire top candidates</h1>

					<div className="tg-header">
						<div className="tg-breadcrumbs l-container">
							<ul className="breadcrumb-items">
								<li className="list-item first-item" onClick={handleBack}>
									<a href="#" className="tg-flat-button">
										<span>Back to test library</span>
									</a>
								</li>
								{/* <li className="list-item">
								<a ">All tests</a></li> */}
							</ul>
						</div>
					</div>
					{createdTestDetailsisLoading ? (<Wave />) :
						createdTestDetailsdata?.length === 0 ? (<div className="sp-load"><BiErrorAlt className="spinner-icon" size={100} color="#cacaca" /></div>) :
							(<div className="fcontainer">
								<div className="l-container">
									<div className="tg-content">
										<div className="tg-section">
											<h2 className="tg-section test-subtitle">Use our Reading comprehension test to hire the best</h2>
											<p>This reading comprehension skills test evaluates candidates’ ability to read a portion of text and comprehend its contents. This pre-employment screening test helps you identify candidates who can process written information and draw appropriate conclusions using analytical thinking.</p>

										</div>
										<div className="tg-section test-skills">
											<h2 className="tg-section test-subtitle">Covered skills</h2>
											<ul>
												<li>
													<CheckOutlinedIcon className="list-icon" />
													Identifying the main thought of a passage</li><li>
													<CheckOutlinedIcon className="list-icon" />
													Making inferences based on a passage</li>
											</ul>
										</div>
										<div className="tg-section tg-content">
											<h2 className="tg-section test-subtitle">Use the Reading comprehension test to hire</h2>
											<p>Any role that involves reading, processing, evaluating, and recalling written information, such as editors, analysts, managers, and others. This test can be particularly useful for remote teams who communicate primarily in writing.</p>
										</div>
									</div>
								</div>
								<div className="r-container">
									<div className="tg-section tg-content">
										<div className="tg-section test-characteristics">
											<div className="tg-card">
												<DescriptionOutlinedIcon className="card-icon" />
												<span className="card-title">Type</span>
												<p>Cognitive ability<br /></p>
											</div>
											<div className="tg-card">
												<TimerOutlinedIcon className="card-icon" />
												<span className="card-title">Time</span>
												<p>10 min</p>
											</div>
											<div className="tg-card">
												<TourOutlinedIcon className="card-icon" />
												<span className="card-title">Languages</span>
												<p>English
													{/* , Spanish, French, Italian, Japanese, Dutch, Portuguese */}
												</p>
											</div>
											<div className="tg-card">
												<BarChartOutlinedIcon className="card-icon" />
												<span className="card-title">Level</span>
												<p>Intermediate</p>
											</div>
										</div>
									</div>
								</div>
								<div className="tg-section tg-button-test">
									<a onClick={handlePreview}>Preview questions</a >
									<a style={{ color: "#fff" }} onClick={handleBack}>Go Back</a>
								</div>
							</div>)}


				</div>
			</main>
		</div>
	);
}

export default TestDetails

